import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { giftSubscriptionSelector as stateSelector } from 'reduxModules/subscriptions/selectors'
import { giftSubscriptionRedeemDispatcher as dispatchSelector } from 'reduxModules/subscriptions/dispatchers'
import withRouterV6 from '../../../utils/withRouterV6'
import keyUpHandler from '../../utils/keyUpHandler'
import CaptchaStandalone from '../../CaptchaStandalone/_lazy'
import { CaptchaNotice } from '../../generic/CaptchaNotice'
import InlineError, { ariaErrorProps } from '../../generic/InlineError'
import useNewsletterDefault from 'hooks/useNewsletterDefault'
import NewsletterConsent from '../../generic/NewsletterConsent'
import '../../generic/RenderedField/styles.css'
import './styles.css'

export function PreSignUp(props) {
  const {
    onSubmit,
    hideGlobalNav,
    showGlobalNav,
    params = {},
    getDetails = () => {},
    firstName = '',
    lastName = '',
    email = ''
  } = props
  const [password1Visible, setPassword1Visible] = useState(false)
  const [password2Visible, setPassword2Visible] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({ defaultValues: { marketingConsent: false } })
  // SPEC-109: the box starts unticked and is ticked from the backend's
  // per-country default unless the person has touched it (signed-out only)
  const { markTouched, touched } = useNewsletterDefault({ setValue, getValues })

  const password1 = watch('password1')

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
  }, [hideGlobalNav, showGlobalNav])

  useEffect(() => {
    if (params.token) getDetails(params.token)
  }, [params.token, getDetails])

  return (
    <div id="PreSignUp" className="auth-page">
      <div>
        <div className="logo">
          <Link to="/">
            <img
              src="/global/assets/images/logo/logo-big.png"
              alt="Stan Winston School Of Character Arts"
            />
          </Link>
        </div>
        <div className="reset-password auth-form-box">
          <h1 className="name">
            {' '}
            Hi {firstName} {lastName}
          </h1>
          <h3 className="email">{email}</h3>
          <div>Set a password and redeem your Subscription</div>
          <form
            id="SignInForm"
            onSubmit={handleSubmit((data) =>
              onSubmit(
                { ...data, marketingConsentTouched: touched.current },
                props
              )
            )}
          >
            <div
              className={classnames('field', '-floating', {
                '-error': errors.password1
              })}
            >
              <div className="field-container">
                <input
                  {...register('password1', {
                    required: 'This field is required.'
                  })}
                  type={password1Visible ? 'text' : 'password'}
                  placeholder=" "
                  id="presignup-password1"
                  {...ariaErrorProps('presignup-password1', errors.password1)}
                />
                <label htmlFor="presignup-password1">New Password</label>
                <i
                  className={classnames(
                    'icon',
                    password1Visible
                      ? 'icon-passcodewatch'
                      : 'icon-passcodewatch disabled'
                  )}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword1Visible(!password1Visible)}
                  onKeyUp={(event) =>
                    keyUpHandler(event, () =>
                      setPassword1Visible(!password1Visible)
                    )
                  }
                  tabIndex="0"
                />
                <InlineError
                  id="presignup-password1"
                  message={errors.password1?.message}
                />
              </div>
            </div>
            <div
              className={classnames('field', '-floating', {
                '-error': errors.password2
              })}
            >
              <div className="field-container">
                <input
                  {...register('password2', {
                    required: 'This field is required.',
                    validate: (value) =>
                      value === password1 || "passwords don't match"
                  })}
                  type={password2Visible ? 'text' : 'password'}
                  placeholder=" "
                  id="presignup-password2"
                  {...ariaErrorProps('presignup-password2', errors.password2)}
                />
                <label htmlFor="presignup-password2">Retype New Password</label>
                <i
                  className={classnames(
                    'icon',
                    password2Visible
                      ? 'icon-passcodewatch'
                      : 'icon-passcodewatch disabled'
                  )}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword2Visible(!password2Visible)}
                  onKeyUp={(event) =>
                    keyUpHandler(event, () =>
                      setPassword2Visible(!password2Visible)
                    )
                  }
                  tabIndex="0"
                />
                <InlineError
                  id="presignup-password2"
                  message={errors.password2?.message}
                />
              </div>
            </div>
            {/* SPEC-099: redeeming a gift creates the recipient's account */}
            <NewsletterConsent
              id="presignup-newsletter"
              inputProps={register('marketingConsent')}
              onTouched={markTouched}
              dark
            />
            <button type="submit" className="btn -wide -orange">
              Start Membership
            </button>
            <CaptchaStandalone />
          </form>
          <CaptchaNotice dark />
        </div>
      </div>
    </div>
  )
}

PreSignUp.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired,
  params: PropTypes.shape({
    token: PropTypes.string
  }),
  getDetails: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string
}

export default withRouterV6(connect(stateSelector, dispatchSelector)(PreSignUp))
